import React from 'react';
import LegalLayout from './legal/LegalLayout';

const CONTACT_EMAIL = 'privacy@dekosta.com';
const SUPPORT_EMAIL = 'destek@dekosta.com';

const Privacy = () => (
  <LegalLayout title="Gizlilik Politikası" lastUpdated="2026-05-24">
    <section>
      <h2 className="text-white font-semibold mb-2">Genel</h2>
      <p>
        Bu metin, DEKOSTA uygulamasını kullanırken kişisel verilerinizin nasıl işlendiğini özetler. Hizmeti
        kullanmaya devam ederek bu politikayı kabul etmiş sayılırsınız.
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">Toplanan veriler</h2>
      <p className="mb-2">
        E-posta ve şifre ile kayıt olduğunuzda e-posta adresiniz, hesap güvenliği için kullanılan hashlenmiş
        parola, otomatik üretilen kullanıcı adı, profil fotoğrafı (Google ile giriş yapıldıysa) ve hesap
        oluşturma zaman damgası işlenir.
      </p>
      <p className="mb-2">
        Aktivasyon ve koleksiyon süreçleri sırasında: aktive ettiğiniz kart kodları, koleksiyon
        ilerlemeniz, başarımlarınız, görev/etkinlik durumlarınız, varsa arkadaşlık ilişkileriniz saklanır.
      </p>
      <p>
        <strong className="text-gray-200">Google ile giriş</strong> kullanırsanız, Google hesabınızdan
        yalnızca oturum açma için gerekli bilgiler (e-posta, ad, profil fotoğrafı) alınır. Bu işlem
        Google&apos;ın o an için geçerli politikalarına tabidir.
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">Verilerin kullanım amacı</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>Hesap oluşturma, oturum açma ve oturum güvenliği</li>
        <li>Koleksiyon, başarım, görev ve aktivasyon akışlarının sunulması</li>
        <li>Kullanıcı destek talepleri</li>
        <li>Kötüye kullanım / sahtekârlık tespiti (brute force koruması, audit log)</li>
        <li>Yasal yükümlülüklerin yerine getirilmesi</li>
      </ul>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">Saklama süresi</h2>
      <p>
        Hesabınız aktif kaldığı sürece veriler saklanır. Hesabınızı sildiğinizde kişisel veriler
        anonimleştirilir. Yasal saklama yükümlülüğü olan audit kayıtları (örn. sahtekârlık tespiti, ödeme
        kayıtları) anonimleştirilmiş şekilde 2 yıl boyunca tutulur.
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">Üçüncü taraflar</h2>
      <p>
        Kişisel verilerinizi pazarlama amacıyla <strong className="text-gray-200">satmıyoruz</strong>.
        Hizmetin işletilmesi için aşağıdaki teknik altyapı sağlayıcıları kullanılır:
      </p>
      <ul className="list-disc pl-5 space-y-1 mt-2">
        <li>MongoDB Atlas (veritabanı barındırma)</li>
        <li>Railway (uygulama sunucusu)</li>
        <li>Vercel (frontend dağıtımı)</li>
        <li>Resend (e-posta gönderimi)</li>
        <li>Sentry (hata izleme)</li>
        <li>Google Identity (opsiyonel OAuth giriş)</li>
      </ul>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">Haklarınız (KVKK m.11 / GDPR Art. 15-22)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>Hangi verilerin işlendiğini öğrenme</li>
        <li>Düzeltme / güncelleme talep etme</li>
        <li>Silme talep etme (hesap içi &quot;Hesabımı sil&quot; veya destek e-postası)</li>
        <li>İşlemeye itiraz etme</li>
        <li>Veri taşınabilirliği (machine-readable export talebi)</li>
      </ul>
      <p className="mt-3">
        Talepleriniz için:{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="text-violet-400 hover:text-violet-300 underline">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">Çocuk gizliliği</h2>
      <p>
        DEKOSTA 13 yaş altı çocuklar için tasarlanmamıştır. 13 yaş altı kullanıcılardan bilerek veri
        toplamayız. 13 yaş altı bir çocuğunun hesabı olduğunu fark ettiyseniz lütfen yukarıdaki destek
        adresinden iletişime geçin.
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">İletişim</h2>
      <p>
        Gizlilik:{' '}
        <a href={`mailto:${CONTACT_EMAIL}`} className="text-violet-400 hover:text-violet-300 underline">
          {CONTACT_EMAIL}
        </a>
        <br />
        Destek:{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="text-violet-400 hover:text-violet-300 underline">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </section>

    <p className="text-xs text-gray-600 pt-4 border-t border-white/10">
      Bu politika güncellenebilir. Önemli değişiklikler uygulama veya web üzerinden duyurulur.
    </p>
  </LegalLayout>
);

export default Privacy;
